import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useNotificationQuery } from '@/lib/query-options';
import { Bell } from 'lucide-react';
import { useAtomValue } from 'jotai';
import { organizationDataAtom } from '@/store';
import { TabCardPanel } from '@/components/glitch-ui/tab-card-panel';
import { PageShell } from '@/components/glitch-ui/page-shell';

export const Route = createFileRoute('/_authenticated/_layout/notifications/')({
  component: NotificationsIndexPage,
  staticData: {
    title: 'Notifications',
    icon: Bell,
  },
});

function NotificationsIndexPage() {
  const organizationData = useAtomValue(organizationDataAtom);
  const navigate = useNavigate();

  const { data: notificationData, isLoading } = useNotificationQuery(
    { organization_id: organizationData?.id },
    1,
    100
  );
  const notifications = notificationData?.items || [];

  // Redirect to first notification when available
  useEffect(() => {
    if (!isLoading && notifications.length > 0) {
      navigate({
        to: '/notifications/$notificationId',
        params: { notificationId: notifications[0].id },
        replace: true,
      });
    }
  }, [isLoading, notifications, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-12 h-12 rounded-full border-4 border-gray-200 border-t-[#290BD9] animate-spin"></div>
      </div>
    );
  }

  // No notifications - show empty state
  if (notifications.length === 0) {
    return (
      <PageShell>
        <TabCardPanel
          tabs={[{ id: 'all', label: 'All Notifications', isActive: true }]}
        >
          <div className="flex flex-col items-center justify-center min-h-[50vh] text-center">
            <Bell className="h-12 w-12 text-gray-500 mb-4" strokeWidth={1} />
            <h3 className="text-lg font-semibold text-gray-500 mb-2">No Notifications</h3>
            <p className="text-gray-500">Notifications will appear here as activity occurs</p>
          </div>
        </TabCardPanel>
      </PageShell>
    );
  }

  // Loading state while redirecting
  return (
    <div className="flex items-center justify-center h-64">
      <div className="w-12 h-12 rounded-full border-4 border-gray-200 border-t-[#290BD9] animate-spin"></div>
    </div>
  );
}
